export const rsvpUser = () => {
    console.log('hello there');
}